<div *ngIf="showMessage" class="mensagem-orientacao">
    <div class="mensagem-orientacao-img">
    </div>
</div>